module.exports = __webpack_public_path__ + "media/images/icons/academic-development_04-c9b68aedf55d7db9428ef63e0ff5a067.svg";